const SERVER_URL = process.env.REACT_APP_API_URL || 'http://localhost:1337';


export const paypalService = {

    async paypalCustomer(payload: { email: string, name: string }){
        try {
            const url = `${SERVER_URL}/api/paypal-customer`;
            const res = await fetch(url, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    email: payload.email,
                    name: payload.name,
                    method: 'paypal'
                }),
            });

            const data = await res.json();
            return data;
        } catch (error) {
            console.error('Error creating subscription:', error);
            throw error;
        }
    },

    async createSimpleSubscription({customerId, paymentMethodId, priceId, secondPrice }: {
        customerId:string,
        paymentMethodId: string,
        priceId: string,
        secondPrice:string }){
        try {
            const url = `${SERVER_URL}/api/paypal-simple-sub`;

            const res = await fetch(url, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    customerId,
                    paymentMethodId,
                    priceId,
                    secondPrice
                }),
            });

            const data = await res.json();
            return data;
        } catch (error) {
            console.error('Error creating subscription:', error);
            throw error;
        }
    },

    async trackPaypalInvoice(subId: string){
        try {
            const url = `${SERVER_URL}/api/paypal-payment-track`;

            const res = await fetch(url, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    subId
                }),
            });

            const data = await res.json();
            return data;
        } catch (error) {
            console.error('Error creating subscription:', error);
            throw error;
        }
    }
}
